/* Program Name: NoSessionContent.js
 **  Description: layout for a major of the application
 **
 **
 ** Project   Date        Who  Comments
 ** --------  ----------  ---  ---------------------------------------------------
 ** IS200243  2022-11-07  STT  Initial program
 *********************************************************************************/

/**React imports */
import { useTheme } from '@mui/material'
import React from 'react'

/**Style imports */

/**GeneralLayout **************************************************************/

const NoSessionContent = (props) => {
  /****************************************************************************/
  /**Local Variables */

  const theme = useTheme()

  /****************************************************************************/
  /**Rendering */

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#ffffff',
        minHeight: '100vh',
        backgroundRepeat: 'no-repeat',
        background:
          'linear-gradient(to left, #FFFFFF 1%, ' +
          theme.palette.secondary.main +
          '0D),' +
          'linear-gradient(' +
          theme.palette.primary.main +
          '4D, ' +
          theme.palette.secondary.main +
          '4D), ' +
          'linear-gradient(45deg, ' +
          theme.palette.primary.main +
          '99 20%, ' +
          theme.palette.primary.main +
          'B3 20%, ' +
          theme.palette.primary.main +
          'B3 40%, ' +
          theme.palette.primary.main +
          'CC 40%, ' +
          theme.palette.primary.main +
          'CC 60%, ' +
          theme.palette.primary.main +
          'E6 60%, ' +
          theme.palette.primary.main +
          'E6 80%, ' +
          theme.palette.primary.main +
          'FF 80%), ' +
          'linear-gradient(-45deg, rgba(91, 91, 91, .1) 20%, ' +
          'rgba(91, 91, 91,.2) 20%, ' +
          'rgba(91, 91, 91,.2) 40%, ' +
          'rgba(91, 91, 91,.4) 40%, ' +
          'rgba(91, 91, 91,.4) 60%, ' +
          'rgba(91, 91, 91,.6) 60%, ' +
          'rgba(91, 91, 91,.6) 80%, ' +
          'rgba(91, 91, 91,.8) 80%), ' +
          'linear-gradient(90deg, rgba(122,122,122,0) 20%, ' +
          'rgba(122,122,122,.3) 20%, ' +
          'rgba(122,122,122,.3) 40%, ' +
          'rgba(122,122,122,.5) 40%, ' +
          'rgba(122,122,122,.5) 60%, ' +
          'rgba(122,122,122,.7) 60%, ' +
          'rgba(122,122,122,.7) 80%, ' +
          'rgba(122,122,122,.8) 80%), ' +
          'linear-gradient(-90deg, ' +
          theme.palette.secondary.main +
          '80 20%, ' +
          theme.palette.secondary.main +
          '99 20%, ' +
          theme.palette.secondary.main +
          '99 40%, ' +
          theme.palette.secondary.main +
          'B3 40%, ' +
          theme.palette.secondary.main +
          'B3 60%, ' +
          theme.palette.secondary.main +
          'CC 60%, ' +
          theme.palette.secondary.main +
          'CC 80%, ' +
          theme.palette.secondary.main +
          'E6 80%)',
        //linear-gradient(rgba(0, 255, 0, .7) .1em, transparent .1em), linear-gradient(90deg, rgba(0, 255, 0, .7) .1em, transparent .1em);
        //background: "linear-gradient(135deg, #FFFFFF 76%, "+theme.palette.secondary.main+"1A 80%, "+theme.palette.secondary.main+"33 84%, "+theme.palette.secondary.main+"4D 84%, "+theme.palette.secondary.main+"4D 88%, "+theme.palette.secondary.main+"66 88%, "+theme.palette.secondary.main+"66 92%, "+theme.palette.secondary.main+"80 92%, "+theme.palette.secondary.main+"80 96%, "+theme.palette.secondary.main+"99 96%),linear-gradient(180deg, rgba(224, 224, 224, 0) 84%, rgba(224, 224, 224,.1) 84%, rgba(224, 224, 224,.1) 88%, rgba(224, 224, 224,.2) 88%, rgba(224, 224, 224,.2) 92%, rgba(224, 224, 224,.4) 92%, rgba(224, 224, 224,.4) 96%, rgba(224, 224, 224,.6) 96%), linear-gradient(90deg, rgba(224, 224, 224,0) 84%, rgba(224, 224, 224,.3) 84%, rgba(224, 224, 224,.3) 88%, rgba(224, 224, 224,.5) 88%, rgba(224, 224, 224,.5) 92%, rgba(224, 224, 224,.7) 92%, rgba(224, 224, 224,.7) 96%, rgba(224, 224, 224,.8) 96%)",
        //linear-gradient("+theme.palette.primary.main+"4D, "+theme.palette.secondary.main+"4D), linear-gradient(45deg, "+theme.palette.primary.main+"4D 20%, "+theme.palette.primary.main+"66 20%, "+theme.palette.primary.main+"66 40%, "+theme.palette.primary.main+"80 40%, "+theme.palette.primary.main+"80 60%, "+theme.palette.primary.main+"99 60%, "+theme.palette.primary.main+"99 80%, "+theme.palette.primary.main+"B3 80%), ,
        //linear-gradient(135deg, #FFFFFF 50%, "+theme.palette.secondary.main+"33),
        backgroundSize: '100% 100%',
      }}
    >
      {props.children}
    </div>
  )
}

export default NoSessionContent
